const en = {
    all: "All",
    allFiles: "All files",
    allowedTypeFile: "Allowed *.jpeg, *.jpg, *.png, *.gif",
    brand: "Brand",
    brandReq: "Must be for example \"Nissan\"",
    bus: "Bus",
    busCreated: "Bus created!",
    busCreatePage: "Bus: Create a new bus",
    busEditPage: "Bus: Edit bus",
    busList: 'Bus List',
    busReport: "Bus Report",
    busStation: "Bus Station",
    buses: "Buses",
    busesOnRoute: "Buses on route",
    cancel: "Cancel",
    chooseLang: "Choose a language",
    circulationCard: "Circulation Card",
    circulationCardRequired: "Circulation Card expiration date is required",
    clear: "Clear",
    code: "Code",
    completedLap: "Completed lap",
    controlPoints: "Control points",
    create: "Create",
    createBus: "Create Bus",
    createDriver: "Create Driver",
    createNewBus: "Create a new bus",
    createNewDriver: "Create a new driver",
    control: "Control",
    date: "Date",
    day: "Day",
    dayReport: "Report Day",
    delete: "Delete",
    deleteBus: "Delete bus",
    deleteBusMessage: "Are you sure want to delete the bus?",
    deleteBusesMessage: "Are you sure want to delete ",
    deleteDriver: "Delete driver",
    deleteDriverMessage: "Are you sure want to delete the driver?",
    deleteDriversMessage: "Are you sure wan to delete ",
    deleteRoute: "Delete route",
    demo: "Demo",
    description: "Description",
    disabled: "Disabled",
    dni: "DNI",
    documentNumberHint: "Must be exactly 8 digits ",
    documentNumberRequired: "Must be for example \"70482540\"",
    download: "Download",
    downloadBtn: "Download",
    downloadControlReport: "Download control report",
    downloadReportFull: "Download report full",
    driver: "Driver",
    driverCreated: "Driver created!",
    driverCreatePage: "Driver: Create a new driver",
    driverEditPage: "Driver: Edit driver",
    driverLicense: "Driver license",
    driverList: "Driver List",
    drivers: "Drivers",
    edit: "Edit",
    editBus: "Edit bus",
    editDriver: "Edit Driver",
    email: "Email",
    enabled: "Enabled",
    enableDriver: "Enable driver",
    errorUpdatingData: "Error updating data",
    filters: "Filters",
    forgotPassword: "Forgot password?",
    friday: "Friday",
    home: "Home",
    historical: "Historical",
    historicalReport: "Reports: Historical",
    incidents: "Incidents",
    inputStringMaxSize: "Maximum 150 characters",
    insurance: "Insurance",
    dateRequired: "Must be for example \"23/05/2023\"",
    labelCancel: "Cancel",
    language: "Language",
    lap: "Lap",
    laps: "Laps",
    lastName: "Last name",
    lastNameRequired: "Must be for example \"Torres\" or \"Torres Silva\"",
    license: "License",
    licenseExpDate: "License",
    licenseExpDateRequired: "Expiry date is required",
    list: "List",
    liveTracking: "Live Tracking",
    login: "Login",
    logout: "Logout",
    management: "Management",
    map: "Map",
    maxSize: "max size of",
    model: "Model",
    modelReq: "Must be for example \"Civilian\"",
    monday: "Monday",
    name: "Name",
    nameRequired: "Must be for example \"Carlos\" or \"Carlos Enrique\"",
    newBus: "New Bus",
    newDriver: "New Driver",
    newRoute: "New Route",
    no: "No",
    noIncidents: "No incidents",
    noResults: "No Results",
    onlyLetters: "Must be only letters",
    options: "Options",
    others: "Others",
    owner: "Owner",
    ownerLastName: "Owner last name",
    ownerName: "Owner name",
    password: "Password",
    penalty: "Penalty",
    phone: "Phone",
    phoneNumberHint: "Must be exactly 9 digits",
    phoneNumberRequired: "Must be for example \"953654423\"",
    plate: "Plate",
    plateRequired: "Must be for example \"A2A588\"",
    profile: "Profile",
    lastGeneratedFile: "Last generated file",
    registeredBus: "Already registered bus",
    registeredDriver: "Already registered driver",
    report: "Report",
    reportByBus: "Reports: By bus",
    reportByDay: "Reports: By day",
    reports: "Reports",
    role: "Role",
    roleRequired: "Must be for example \"Chofer\"",
    route: "Route",
    routeCreatePage: "Route: Create a new route",
    routeRequired: "Route is required",
    routes: "Routes",
    saturday: "Saturday",
    saveChanges: "Save Changes",
    searchBtn: "Search",
    search: "Search...",
    searchByBusOptions: "Search by plate",
    searchByDriverOptions: "Search by name, plate or phone number",
    selectPlateRequired: "Select a plate",
    selectRouteRequired: "Select a route",
    selected: "Selected",
    settings: "Settings",
    showIncidents: "Show incidents",
    showTrack: "Show track",
    signIn: "Sign In",
    status: "Status",
    sunday: "Sunday",
    thursday: "Thursday",
    tuesday: "Tuesday",
    turnOffAutoTime: "Turn off auto time",
    turnOffGps: "Turn off GPS",
    turnOffInternet: "Turn off Internet",
    turnOnAutoTime: "Turn on auto time",
    turnOnGps: "Turn on GPS",
    turnOnInternet: "Turn on Internet",
    successCreateDriver: "Driver created!",
    uncompletedLap: "Uncompleted lap",
    unknown: "Unknown",
    unknownIncident: "Unknown incident",
    updatedBus: "Updated bus!",
    updatedDriver: "Updated driver!",
    updatedDrivers: "Updated drivers!",
    updatePhoto: "Update photo",
    uploadControlPoints: "Upload control points",
    uploadFrequency: "Upload frequency",
    uploadPhoto: "Upload photo",
    uploadRoutes: "Upload routes",
    users: "Users",
    wednesday: "Wednesday",
    yearProduction: "Year",
    yearProductionRequired: "Must be for example \"2005\"",
    yes: "Yes",
    msgInvalidPass: "Invalid password",
    msgUserNotFound: "User not found",
    msgUserTempDisabled: "User temporally disabled since many failed attempts. Contact your administrator",
    msgErrorFound: "Ops, error found",
    labelSelectRoute: "Select a route",
    labelHour: 'Hour',
    labelMonth: "Month",
    labelPlate: 'Plate',
    labelStatus: 'Status',
    labelRoute: 'Route',
    msgReportDay: "Select the day and the route to download their report",
    msgReportMonth: "Select the month and year to view reports already generated",
    msgDeleteRoute: "Are you sure want to delete the route?",
    titleRouteNotSelected: "No routes selected",
    msgSelectRoute: "Select a route to show results",
    frequencies: "Frequencies",
    information: "Information",
    routeInfoCreated: "Route information created!",
    updatedRouteInfo: "Updated route information!",
    registeredRouteInfo: "Already registered route information!",
    variant: "Variant",
    routeCodeRequired: "Must be for example \"1A_CN\" or \"1B_M\"",
    routeCodeHint: "The maximum is 10 characters, no spaces",
    routeNameRequired: "Must be for example \"1A Ciudad Nueva\" or \"1B Miramar\"",
    numberRequired: "It must be a number",
    positiveNumberRequired: "It must be equal to or greater than 0",
    onlyAlphanumeric: "Only alphanumeric",
    routeVariantRequired: "Must be for example \"With students\" or \"No students\"",
    latitude: "Latitude",
    longitude: "Longitude",
    penalized: "Penalized",
    visible: "Visible",
    add: "Add",
    pointNameRequired: "Must be for example \"Departure\", \"Finish\" or \"Genovesa\"",
    latitudeHint: "Only numbers between -90 and 90 with maximum 6 decimals",
    longitudeHint: "Only numbers between -180 and 180 with maximum 6 decimals",
    pointsCreated: "Points created!",
    pointsCreationFailed: "Points creation failed!",
    updatedPoints: "Updated points!",
    errorUpdatingPoints: "Error updating points",
    restore: "restore",
    points: "points",
    graceMinutes: "Grace Minutes",
    graceMinutesPerLap: "Grace Minutes per Lap",
    stationLocation: "Main Station Location",
    graceMinutesLimit: "It must be less than or equal to grace minutes per day",
    pointCodeRequired: "It must be for example \"S\" or \"PXII\"",
    pointCodeHint: "The maximum is 5 characters",
    controlTimes: "Control times",
    range: "Range",
    start: "Start",
    end: "End",
    controlTimesCreated: "Control times created!",
    controlTimesCreationFailed: "Control times creation failed!",
    updatedControlTimes: "Updated control times!",
    errorUpdatingControlTimes: "Error updating control times",
    noChanges: "No changes",
    departurePointHint: "Departure point must be 0",
    timeReq: "It must be an hour",
    startTimeGreaterHint: "It must be greater than previous end time",
    startTimeLessHint: "It must be less than end time",
    endTimeGreaterHint: "It must be greater than start time",
    departureTimes: "Departure times",
    details: "Details",
    frequency: "Frequency",
    departureTimesCreated: "Departure times created!",
    departureTimesCreationFailed: "Departure times creation failed!",
    updatedDepartureTimes: "Updated departure times!",
    errorUpdatingDepartureTimes: "Error updating departure times",
    routeCreated: "Route created!",
    routeCreationFailed: "Route creation failed!",
    uploadPath: "Upload Path",
    pathCreated: "Path created!",
    pathCreationFailed: "Path creation failed!",
    requestDataDeletion: "Request data deletion",
    removeData: "Remove data",
    userDataRemove: "User data remove",
    send: "Send",
    greetings: "Greetings!",
    messageInformative: "Dear user, your personal data will be permanently deleted. Please enter your phone number with which you registered.",
    thanks: "Thanks!",
    contactMessage: "In the next few days we will contact you.",
    labelContinue: "Continue",
    automatedControl: "Automated control",
    departures: "Departures",
    disable: "Disable",
    updatedDriversFailed: "Failed to update drivers!",
    exportDrivers: "Export drivers",
    updateDrivers: "Update drivers",
    editRoute: "Edit route",
    downloadPath: "Download Path",
    errorGetPathFile: "There isn't path file",
    pathFileCreationFailed: "Failed to create path file!",
    controlMode: "Control Mode",
    selectControlModeRequired: "Select a control mode",
    announcement: "Announcement",
    message: "Message",
    announcementCreated: "Announcement created!",
    announcementCreationFailed: "Announcement creation failed!",
    messageRequired: "Message is required",
    stations: "Stations",
    newStation: "New Station",
    stationCreatePage: "Station: Create a new station",
    stationEditPage: "Station: Edit station",
    station: "Station",
    editStation: "Edit station",
    stationNameReq: "Station name is required",
    expirationDate: "Expiration date",
    stationCodeReq: "Station code is required",
    stationCreated: "Station created!",
    registeredStation: "Already registered station!",
    unitsPerColumn: "Units per column",
    updatedStation: "Updated station!",
    errorUpdatingStation: "Error updating station",
    onlyNumber: "It must be greater than 0",
    scheduleConfiguration: "Schedules: Configuration",
    configuration: "Configuration",
    newSchedule: "New Schedule",
    scheduleCreatePage: "Schedule: create a new schedule",
    groups: "Groups",
    selectGroupRequired: "Select a group",
    scheduleSettingsCreated: "Schedule settings created!",
    registeredScheduledSettings: "Already registered schedule settings!",
}

export default en